import { useEffect } from 'react';

/**
 * Health check page for deployment health probes
 * Returns a JSON-like response that can be used by health checkers
 */
const Health = () => {
  useEffect(() => {
    // Set content type to JSON for health check crawlers
    document.title = 'Health Check';
  }, []);

  return (
    <pre style={{ fontFamily: 'monospace', padding: '20px' }}>
      {JSON.stringify({ status: 'healthy', service: 'ltv-production', timestamp: new Date().toISOString() }, null, 2)}
    </pre>
  );
};

export default Health;
